import { render } from "./AddModelType.vue?vue&type=template&id=4c5b6a3a"
import script from "./AddModelType.vue?vue&type=script&lang=js"
export * from "./AddModelType.vue?vue&type=script&lang=js"

import "./AddModelType.vue?vue&type=style&index=0&id=4c5b6a3a&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__